import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRedirectById } from "store/redirectsSlice";
import s from "./RedirectForUser.module.css";

const RedirectForUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, error } = useSelector((state) => state.redirects);
  const [redirectData, setRedirectData] = useState(null);

  useEffect(() => {
    const fetchRedirect = async () => {
      if (id) {
        try {
          const result = await dispatch(getRedirectById(id)).unwrap();
          if (result && result.data && result.data.redirectlink) {
            setRedirectData(result.data);

            let redirectUrl = result.data.redirectlink;
            if (!redirectUrl.startsWith("http://") && !redirectUrl.startsWith("https://")) {
              redirectUrl = "https://" + redirectUrl;
            }

            // Перенаправляем пользователя
            window.location.href = redirectUrl;
          }
        } catch (err) {
          console.error("Ошибка при получении редиректа:", err);
        }
      }
    };

    fetchRedirect();
  }, [id, dispatch]);

  if (loading) {
    return (
      <div className={s.container}>
        <div className={s.loading}>
          <h2>Перенаправление...</h2>
          <div className={s.spinner}></div>
          <p>Пожалуйста, подождите</p>
        </div>
      </div>
    );
  }

  if (error || !redirectData) {
    return (
      <div className={s.container}>
        <div className={s.error}>
          <h2>Ошибка</h2>
          <p>{error || "Редирект не найден"}</p>
          <button
            onClick={() => navigate("/")}
            className={s.homeButton}
          >
            Вернуться на главную
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default RedirectForUser;
